/** Created by azhou on 2018/10/11.*/
<template>
  <div>
    <div id="hotelMap"></div>
    <!-- <div class="control-map" @click="controlMap">
      <span v-show="!showBigMap">展开地图</span>
      <span v-show="showBigMap">收起地图</span>
    </div> -->
        <!-- <el-dialog  
        :visible.sync="confirmPanelShow" 
        width="1000px"  
        center  
        :z-index="11"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"  
        >
      </el-dialog> -->
      <!--代订收款弹窗-->
      <OrderCollectionOnDehalf :collectionShow="collectionShow" :orderDetail="orderDetail" ref="collectionOnDehalf"  @onShow="collectionShow=false" />
  </div>
</template>

<script>
  import OrderCollectionOnDehalf from './Comp/OrderRoomType' //代订收款弹窗 
  import {mapState} from 'vuex'
  // 复杂的自定义覆盖物
  function ComplexCustomOverlay(point, text, mouseoverText,totalPrice,hotel_offer,offer_remark,vueInstance,hotelInfo,meeting_offer_arr) {
    this._point = point;
    this._text = text;
    this._overText = mouseoverText;
    this._totalPrice=totalPrice;
    this._hotel_offer=hotel_offer;
    this.offer_status=hotel_offer==''?0:1;
    this.offer_remark=offer_remark==''?'无':offer_remark;
    this.vueInstance=vueInstance;
    this._hotelInfo=hotelInfo;
    this._meeting_offer_arr=meeting_offer_arr;
  }
  //定义构造函数并继承Overlay
  ComplexCustomOverlay.prototype = new BMap.Overlay();
  ComplexCustomOverlay.prototype.initialize = function(map) {
    const _this = this.vueInstance;
    this._map = map;
    //外层div
    let div = this._div = document.createElement('div');
    div.classList.add("myrk");
    div.style.position = 'absolute';
    div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
    let _divs = this._divs = document.createElement('p');
    _divs.style.backgroundColor = '#fff';
    _divs.style.color = '#0698ff';
    _divs.style.border = '1px solid #999';
    // div.style.borderLeft = 'none';
    // div.style.height = '26px';
    _divs.style.lineHeight = '26px';
    _divs.style.padding = '0 20px 0 20px';
    _divs.style.borderTopRightRadius = '6px';
    _divs.style.borderBottomRightRadius = '6px';
    _divs.style.borderBottomLeftRadius = '6px';
    _divs.style.whiteSpace = 'nowrap';
    _divs.style.fontSize = '12px';
    div.appendChild(_divs);
    //酒店标题
    let span = this._span = document.createElement('div');
    span.style.color='#0698ff';
    span.style.fontWeight='bold';
    span.style.fontSize='14px';
    span.appendChild(document.createTextNode(this._text));
    _divs.appendChild(span);
    //酒店星级
    let span_star = this._span = document.createElement('span');
    span_star.appendChild(document.createTextNode('四星级'));
    span_star.style.marginLeft='10px';
    span_star.style.color='#f90';
    span_star.style.fontSize='12px';
    span.appendChild(span_star);
    //酒店房间报价
    if(this._hotelInfo.offer_type==1){
      let div_room = this._span = document.createElement('div');
      let room_price=this._hotelInfo.room_minPrice==this._hotelInfo.room_maxPrice?this._hotelInfo.room_minPrice:this._hotelInfo.room_minPrice+'~'+this._hotelInfo.room_maxPrice;
      div_room.appendChild(document.createTextNode(`用房报价：${room_price}元/间`));
      div_room.style.color='#919191';
      _divs.appendChild(div_room);
      //酒店会议室报价
      if(this._hotelInfo.meeting_maxPrice){
        let div_address = this._span = document.createElement('div'); 
        let meeting_price=this._hotelInfo.meeting_minPrice==this._hotelInfo.meeting_maxPrice?this._hotelInfo.meeting_minPrice:this._hotelInfo.meeting_minPrice+'~'+this._hotelInfo.meeting_maxPrice;
        div_address.appendChild(document.createTextNode(`会议报价：${meeting_price}元`));
        div_address.style.color='#919191';
        _divs.appendChild(div_address);
      }
          //查看出更多
      let more = this._more = document.createElement('div');
      more.style.backgroundColor = '#0698ff';
      more.style.color = '#fff';
      more.style.width = '100%';
      more.style.height = '28px';
      more.style.lineHeight = '28px';
      more.style.borderRadius = '4px';
      more.style.marginTop='4px'; 
      more.style.marginBottom='6px';
      more.style.overflow = 'hidden';
      more.style.fontSize = '12px';
      more.style.textAlign = 'center';
      more.appendChild(document.createTextNode('查看明细'));
      more.addEventListener("click", ()=>{
        let hotelInfo={
          ...this._hotelInfo,
          room_need_arr:this._hotelInfo.room_offer_arr,
          meeting_need_arr:this._hotelInfo.meeting_offer_arr,
          deal_time:1
        };
        console.log(hotelInfo);
        _this.orderDetail=hotelInfo;
        _this.collectionShow=true;
      });
      _divs.appendChild(more);
    }
     let spanos = this._span = document.createElement('span');
    _divs.appendChild(spanos);
    // i.appendChild(document.createTextNode(this._totalPrice));
    // for(let item  in this._hotel_offer.slice(0, 4)){
    //   for(let lpn  in this._hotel_offer[item].offer_info){
    //     let p = this._p = document.createElement('p');
    //     let spanns = this.span = document.createElement('span');
    //     p.style.color='#919191';
    //     spanns.style.color='#f72221';
    //     if(lpn>0){
    //      p.style.marginTop='-6px';
    //     }
    //     let nams=this._hotel_offer[item].offer_info[lpn].offer_title;
    //     let HRoomPrice=this._hotel_offer[item].offer_info[lpn].offer_price;
    //       // if(nams==''){
    //       //   switch (this._hotel_offer[lpn].style) {
    //       //     case 1:nams='大床房'
    //       //     break;
    //       //     case 2:nams= '双床房'
    //       //     break;
    //       //     case 3:nams= '三床房'
    //       //     break;
    //       //     case 4:nams= '司陪房'
    //       //   }
    //       // }
    //     if(this.offer_status===1){
    //       spanos.appendChild(p);
    //       p.appendChild(document.createTextNode(nams+': '));
    //       p.appendChild(spanns);
    //       spanns.appendChild(document.createTextNode(HRoomPrice));
    //       p.appendChild(document.createTextNode('元 / 晚'));
    //     }
    //   }
    // }
    if(this._hotelInfo.offer_type==2){
        let p = this._p = document.createElement('p');
        let spanns = this.span = document.createElement('span');
        p.style.color='#919191';
        spanns.style.color='#f72221';
        spanos.appendChild(p);
        p.appendChild(document.createTextNode('接不了: '+this.offer_remark));
    }
    //图标
    let arrow = this._arrow = document.createElement('div');
    arrow.addEventListener("click", open);
    arrow.style.background = 'url(/images/public/hotel-map.png) no-repeat';
    arrow.style.position = 'absolute';
    arrow.style.width = '32px';
    arrow.style.height = '32px';
    arrow.style.top = '-3px';
    arrow.style.left = '-16px';
    arrow.style.overflow = 'hidden';
    //关闭图标
    let none = this._none = document.createElement('div');
    div.appendChild(none);
    none.style.position = 'absolute';
    none.style.top = '4px';
    none.style.fontSize = '16px';
    none.style.textAlign='center';
    none.style.right = '5px';
    none.style.color = '#999';
    none.style.width = '13px';
    none.style.height = '16px';
    none.style.lineHeight = '16px';
    none.appendChild(document.createTextNode('x'));
    none.addEventListener("click", attributes);
    //序号
    let span2 = this._span2 = document.createElement('span');
    arrow.appendChild(span2);
    span2.style.position = 'absolute';
    span2.style.top = '50%';
    span2.style.left = '50%';
    span2.style.transform = 'translate(-50%, -60%)';
    span2.style.color = '#fff';
    span2.style.width = 'auto';
    span2.style.height = '32px';
    span2.style.lineHeight = '32px';
    span2.appendChild(document.createTextNode(this._overText));
    div.appendChild(arrow);
    this._map.getPanes().labelPane.appendChild(div);
    return div;
  };
  ComplexCustomOverlay.prototype.draw = function() {
    let map = this._map;
    let pixel = map.pointToOverlayPixel(this._point);
    this._div.style.left = pixel.x - parseInt(this._arrow.style.left) + 'px';
    this._div.style.top = pixel.y - 30 + 'px';
  };
  // 自定义覆盖物添加事件方法
  ComplexCustomOverlay.prototype.addEventListener = function (event, fun) {
      this._div['on' + event] = fun;
  }
  let nsd=1;
  //attribute事件
  function attribute(e) {
    let zin=$(this).css('zIndex');
    if(nsd===1){
      $(this).siblings().each(function(index){
      $(this).css({'zIndex': index});
      });
      $(this).css({ 'zIndex':99});
      nsd++
    }else{
      nsd++
      $(this).css({ 'zIndex': 99*nsd});
    }
  }
  function attributes(e){
    $(this).siblings('p').css({ 'display':'none'});
    $(this).css({ 'display':'none'});
  }
  function open(){
    $(this).siblings().css({ 'display':'block'});
  }
  export default {
    data() {
      return {
        map:'',
        BMap:'',
        showBigMap:false,
        collectionShow:false,
        orderDetail:{},      //详情明细
      }
    },
    components: {
      OrderCollectionOnDehalf,
    },
    mounted() { this.initMap();},
    watch:{
      'HotterOfferLists':'addMaker'
    },
    computed: {
      ...mapState(['HotterOfferLists']),
    },
    methods:{
      initMap() {
        this.map = new BMap.Map('hotelMap');                 // 创建地图实例
        this.map.centerAndZoom(new BMap.Point(116.3964, 39.9093), 15);                    // 初始化地图，设置中心点坐标和地图级别
        this.map.enableScrollWheelZoom(true);                //开启鼠标滚轮缩放
        this.map.addControl(new BMap.NavigationControl({
          anchor:BMAP_ANCHOR_TOP_RIGHT
        }));   //平移缩放控件
        this.map.addControl(new BMap.ScaleControl());        //比例尺控件
        //批量添加marker
        this.addMaker();
      },
      /*添加标注到百度地图*/
      addMaker() {  
        let HotterOfferLists=JSON.parse(localStorage.getItem('Lawyer'));
        console.log(HotterOfferLists);
        let hotelArr = HotterOfferLists.map(v => {
          v.lng = v.lng || v.hotel_longitude;
          v.lat = v.lat || v.hotel_latitude;
          v.hotel_name = v.hotel_name || v.hotel_title;
          v.tosn=' 总金额:'+v.offer_price+'元 '
          return v;
        });
        //批量添加marker
        for (let i = 0; i < hotelArr.length; i++) {
          this.map.centerAndZoom(new BMap.Point(hotelArr[0].lng, hotelArr[0].lat), 11);                    // 初始化地图，设置中心点坐标和地图级别||hotelArr[i].meeting_offer_arr.list
            let point = new BMap.Point(hotelArr[i].lng, hotelArr[i].lat);
            let myCompOverlay = new ComplexCustomOverlay(point, hotelArr[i].hotel_name,i + 1,hotelArr[i].tosn,hotelArr[i].room_offer_arr.list,hotelArr[i].offer_remark,this,hotelArr[i],hotelArr[i].meeting_offer_arr.list);
            this.map.addOverlay(myCompOverlay);
            myCompOverlay.addEventListener("click", attribute);
        }
      },
      /*展开收起地图*/
      controlMap() {
        this.showBigMap = !this.showBigMap;
        if (this.showBigMap) $('#hotelMap').height(600);
        else $('#hotelMap').height(300);
      }
    }
  }
</script>
<style lang="scss" scoped>
  #hotelMap{ 
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }
  .control-map{
    background: #cfdbf7;
    padding:10px 0;
    cursor: pointer;
    font-size: 16px;
    &:hover{background: #DDE9F7;}
  }
</style>
